import {LobbyWrapperDefaultBox, LobbyWrapperWithoutBackgroundDefaultBox} from "./lobby-wrapper.default.box";
import {styledByTheme} from "../../themes/architecture/styled-by-theme";
import {LobbyWrapperCasino777Box} from "./lobby-wrapper.casino777.box";
import { LobbyWrapperSiCisBox } from "./lobby-wrapper.siCis.box";
import {LobbyWrapperWsopBox} from "./lobby-wrapper.wsop.box";

export const LobbyWrapperBox = styledByTheme(LobbyWrapperDefaultBox)
    .forCasino777(LobbyWrapperCasino777Box)
    .forSI(LobbyWrapperWithoutBackgroundDefaultBox)
    .forMrGreen(LobbyWrapperWithoutBackgroundDefaultBox)
    .forSICis(LobbyWrapperSiCisBox)
    .forWsop(LobbyWrapperWsopBox)
    .apply();